import { supabase } from './supabase';

// Logística Fase 2. Todas las escrituras son idempotentes por client_uuid (como el resto de la app).

// Sugiere el mejor hueco para una matrícula (solo lectura). Devuelve [{codigo, puntuacion, motivo}].
export async function sugerirUbicacion(tenant_id, lpn_codigo, almacen_id, limite = 3) {
  const { data, error } = await supabase.rpc('sugerir_ubicacion', {
    p_tenant: tenant_id, p_lpn_codigo: lpn_codigo, p_almacen_id: almacen_id, p_limite: limite,
  });
  if (error) throw error;
  return data || [];
}

// Hoja de carga de un pedido (solo lectura). Devuelve filas {parada, ubicacion, lpn, descripcion, lote, caducidad, unidades, estado}.
export async function hojaCarga(pedido_id) {
  const { data, error } = await supabase.rpc('hoja_carga', { p_pedido_id: pedido_id });
  if (error) throw error;
  return data || [];
}

// Estado agregado del pedido (previstos / en_almacen / expedidos / sin_producir).
export async function pedidoEstado(pedido_id) {
  const { data, error } = await supabase.from('v_pedido_estado').select('*').eq('pedido_id', pedido_id).maybeSingle();
  if (error) throw error;
  return data || null;
}

// Devuelve al rack un palet que se había quedado en muelle.
export async function devolverDeMuelle(tenant_id, lpn_codigo, ubicacion_codigo, client_uuid) {
  const { data, error } = await supabase.rpc('devolver_de_muelle', {
    p_tenant: tenant_id, p_lpn_codigo: lpn_codigo, p_ubicacion_codigo: ubicacion_codigo, p_client_uuid: client_uuid,
  });
  if (error) throw error;
  return data;
}

// Confirma la mercancía de un palet (matrícula impresa antes de existir): crea contenido, movimiento de ENTRADA
// y ubica. Si p_cantidad es null usa unidades_previstas; si p_ubicacion_codigo es null deja el hueco actual.
// Devuelve {ok, lpn, cantidad, previstas, difiere, ubicacion, movimiento_id}. Idempotente por client_uuid.
export async function confirmarPalet({ tenant_id, lpn_codigo, client_uuid, cantidad = null, ubicacion_codigo = null, lote = null, caducidad = null, proveedor = null, codigo_externo = null }) {
  const { data, error } = await supabase.rpc('confirmar_palet', {
    p_tenant: tenant_id, p_lpn_codigo: lpn_codigo, p_client_uuid: client_uuid,
    p_cantidad: cantidad, p_ubicacion_codigo: ubicacion_codigo, p_lote: lote, p_caducidad: caducidad,
    p_proveedor: proveedor, p_codigo_externo: codigo_externo,
  });
  if (error) throw error;
  return data;
}

// ¿El palet está pendiente de control de calidad? Bandera ESTRUCTURAL (hueco.lpn.en_cuarentena),
// nunca por texto. confirmar_palet la pone a true; calidad_palet a false al liberar/rebloquear.
// motivo_bloqueo solo se MUESTRA, jamás decide.
export const esCuarentena = (l) => !!l && l.en_cuarentena === true;

// Control de calidad de un palet en cuarentena. p_liberar=true libera; false bloquea (p_motivo OBLIGATORIO).
// Devuelve {ok, lpn, estado}.
export async function calidadPalet({ tenant_id, lpn_codigo, liberar, motivo = null }) {
  const { data, error } = await supabase.rpc('calidad_palet', {
    p_tenant: tenant_id, p_lpn_codigo: lpn_codigo, p_liberar: liberar, p_motivo: motivo,
  });
  if (error) throw error;
  return data;
}

// DESHACER (corrección). NUNCA borra: la RPC hueco.deshacer_movimiento (la crea el usuario en Supabase)
// inserta el movimiento INVERSO con motivo "Corrección de <id>" y traza de quién. La RPC valida servidor:
// ventana de 5 min, solo el propio usuario y solo si el palet no se movió después. Idempotente por client_uuid.
// Contrato esperado: deshacer_movimiento(p_tenant uuid, p_movimiento_id uuid, p_client_uuid uuid)
//   OK    -> { ok:true, movimiento_inverso_id, tipo:'CORRECCION', motivo }
//   ERROR -> RAISE con: HUECO_DESHACER_FUERA_VENTANA | HUECO_DESHACER_NO_TUYO |
//                       HUECO_DESHACER_PALET_MOVIDO | HUECO_DESHACER_YA_HECHO
export async function deshacerMovimiento({ tenant_id, movimiento_id, client_uuid }) {
  const { data, error } = await supabase.rpc('deshacer_movimiento', {
    p_tenant: tenant_id, p_movimiento_id: movimiento_id, p_client_uuid: client_uuid,
  });
  if (error) throw error;
  return data;
}

// --- RETIRADA / RECALL (Bloque 1). Todas las RPC ya existen en Supabase. ---
// Bloquea un hueco Y los palets que contiene (motivo OBLIGATORIO). Queda en Auditoría 'BLOQUEO'.
export async function bloquearUbicacion(tenant_id, codigo, motivo) {
  const { data, error } = await supabase.rpc('bloquear_ubicacion', { p_tenant: tenant_id, p_codigo: codigo, p_motivo: motivo });
  if (error) throw error;
  return data;
}
// Desbloquea (solo owner/admin). Auditoría 'DESBLOQUEO'.
export async function desbloquearUbicacion(tenant_id, codigo, motivo) {
  const { data, error } = await supabase.rpc('desbloquear_ubicacion', { p_tenant: tenant_id, p_codigo: codigo, p_motivo: motivo });
  if (error) throw error;
  return data;
}
// Inmoviliza DE GOLPE todos los huecos con ese lote. Auditoría 'INMOVILIZACION_LOTE'.
// Devuelve {ubicaciones, unidades_inmovilizadas, detalle[], ya_servido[]}.
export async function inmovilizarLote(tenant_id, lote, motivo) {
  const { data, error } = await supabase.rpc('inmovilizar_lote', { p_tenant: tenant_id, p_lote: lote, p_motivo: motivo });
  if (error) throw error;
  return data;
}
// Levanta la inmovilización (recall) de TODOS los huecos de un lote. Auditoría 'LEVANTAR_INMOVILIZACION'.
// Devuelve {ubicaciones, unidades, detalle[] con {ubicacion, unidades, motivo_levantado}}.
export async function liberarLote(tenant_id, lote, motivo) {
  const { data, error } = await supabase.rpc('liberar_lote', { p_tenant: tenant_id, p_lote: lote, p_motivo: motivo });
  if (error) throw error;
  return data;
}
// Trazabilidad completa de un lote (solo lectura): {lote, en_almacen[], entradas[], salidas[], bloqueos[]}.
export async function trazabilidadLote(tenant_id, lote) {
  const { data, error } = await supabase.rpc('trazabilidad_lote', { p_tenant: tenant_id, p_lote: lote });
  if (error) throw error;
  return data;
}
// Sugerencia FEFO (Bloque 5): líneas ordenadas por caducidad, excluye huecos bloqueados.
export async function sugerirFefo(tenant_id, sku, cantidad) {
  const { data, error } = await supabase.rpc('sugerir_fefo', { p_tenant: tenant_id, p_sku: sku, p_cantidad: cantidad });
  if (error) throw error;
  return data || [];
}
// Integridad del stock (Bloque 3): compara el LIBRO contra la tabla de stock. {cuadra, descuadres, detalle[], negativos}.
export async function integridadStock(tenant_id) {
  const { data, error } = await supabase.rpc('integridad_stock', { p_tenant: tenant_id });
  if (error) throw error;
  return data;
}

// --- RESERVA DURA DE CARGA (Bloque 8). RPCs del usuario. ---
// Reserva por FEFO (salta bloqueados y cuarentena). IDEMPOTENTE: rehace la reserva del pedido desde cero.
// → {ok, reservas, lineas:[{sku, descripcion, pedidas, reservadas, faltan, completa, detalle:[{ubicacion,lote,caducidad,cantidad,dias}]}], completo}
export async function reservarCarga(tenant_id, pedido_id) {
  const { data, error } = await supabase.rpc('reservar_carga', { p_tenant: tenant_id, p_pedido_id: pedido_id });
  if (error) throw error;
  return data;
}
// Libera lo reservado (al cancelar o cerrar el pedido).
export async function liberarReserva(tenant_id, pedido_id) {
  const { data, error } = await supabase.rpc('liberar_reserva', { p_tenant: tenant_id, p_pedido_id: pedido_id });
  if (error) throw error;
  return data;
}

// --- CARGA INICIAL DE INVENTARIO (RPCs del usuario, NO modificar). ---
// Alta/actualización de catálogo desde plantilla. p_filas = array JSON.
// → {ok, filas, altas, actualizados, errores:[{fila, sku, motivo}]}. SKU existente se actualiza (no duplica).
export async function importarArticulos(tenant_id, filas) {
  const { data, error } = await supabase.rpc('importar_articulos', { p_tenant: tenant_id, p_filas: filas });
  if (error) throw error;
  return data;
}
// Stock existente como movimiento de RECUENTO (motivo «Inventario inicial»), no recepción.
// → {ok, filas, cargadas, unidades, errores:[{fila, motivo}]}. Si el inventario del almacén está cerrado, la RPC lanza excepción con la fecha.
export async function importarStockInicial(tenant_id, almacen_id, filas) {
  const { data, error } = await supabase.rpc('importar_stock_inicial', { p_tenant: tenant_id, p_almacen_id: almacen_id, p_filas: filas });
  if (error) throw error;
  return data;
}
